import {
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  Launch as LaunchIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
} from '../icons';
import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, IconButton, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[100],
      }}
    >
      {/* merchQRy Advertisement Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 4,
          px: 2,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            Powered by merchQRy
          </Typography>
          <Typography variant="body1" paragraph sx={{ mb: 3, opacity: 0.9 }}>
            Build your own restaurant ordering platform and grow your food business with merchQRy.
            Join thousands of restaurants already using our platform.
          </Typography>
          <Button
            variant="contained"
            size="large"
            endIcon={<LaunchIcon />}
            href="https://merchqry.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              border: '2px solid rgba(255, 255, 255, 0.3)',
              backdropFilter: 'blur(10px)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                border: '2px solid rgba(255, 255, 255, 0.5)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
              px: 4,
              py: 1.5,
            }}
          >
            Start Your Platform Today
          </Button>
        </Container>
      </Box>

      {/* Main Footer Content */}
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                merchQRy
              </Typography>
              <Typography variant="body2" color="text.secondary">
                The easiest way to order food at your table. Scan, browse, order, and pay - all from your phone.
              </Typography>
              <Box sx={{ mt: 2 }}>
                <IconButton color="primary" aria-label="facebook">
                  <FacebookIcon />
                </IconButton>
                <IconButton color="primary" aria-label="twitter">
                  <TwitterIcon />
                </IconButton>
                <IconButton color="primary" aria-label="instagram">
                  <InstagramIcon />
                </IconButton>
                <IconButton color="primary" aria-label="linkedin">
                  <LinkedInIcon />
                </IconButton>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                For Customers
              </Typography>
              <Box>
                <Link component={RouterLink} to="/how-it-works" color="inherit" display="block" sx={{ mb: 1 }}>
                  How It Works
                </Link>
                <Link component={RouterLink} to="/faq" color="inherit" display="block" sx={{ mb: 1 }}>
                  FAQ
                </Link>
                <Link component={RouterLink} to="/support" color="inherit" display="block" sx={{ mb: 1 }}>
                  Support
                </Link>
                <Link component={RouterLink} to="/privacy" color="inherit" display="block" sx={{ mb: 1 }}>
                  Privacy Policy
                </Link>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                For Restaurants
              </Typography>
              <Box>
                <Link component={RouterLink} to="/register" color="inherit" display="block" sx={{ mb: 1 }}>
                  Sign Up
                </Link>
                <Link component={RouterLink} to="/pricing" color="inherit" display="block" sx={{ mb: 1 }}>
                  Pricing
                </Link>
                <Link component={RouterLink} to="/features" color="inherit" display="block" sx={{ mb: 1 }}>
                  Features
                </Link>
                <Link component={RouterLink} to="/testimonials" color="inherit" display="block" sx={{ mb: 1 }}>
                  Testimonials
                </Link>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                Contact Us
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                123 Main Street
                <br />
                New York, NY 10001
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Email: info@merchqry.com
                <br />
                Phone: (123) 456-7890
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <Typography variant="body2" color="text.secondary">
              © {currentYear} merchQRy. All rights reserved.
            </Typography>
            <Box>
              <Link href="/terms" color="inherit" sx={{ mr: 2 }}>
                Terms of Service
              </Link>
              <Link href="/privacy" color="inherit">
                Privacy Policy
              </Link>
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Footer;
